<template>
    <b-dropdown
        :id="`actions-to-edit-or-delete-initiative-${initiativeId}`"
        class="actions"
        size="sm"
        variant="link"
        toggle-class="text-decoration-none m-0 p-0"
        no-caret
        dropleft
        boundary="window"
        :disabled="disabled"
    >
        <template slot="button-content">
            <i class="fas fa-ellipsis-v" />
        </template>
        <b-dropdown-item-button id="btn-okr-edit-objective" @click="openEditInitiativeModal(initiativeId)">
            <strong class="text-muted">{{ $t('form.button.edit') }}</strong>
        </b-dropdown-item-button>
        <b-dropdown-item-button id="btn-okr-delete-objective" @click="confirmDelete">
            <strong class="text-muted">{{ $t('form.button.delete') }}</strong>
        </b-dropdown-item-button>
        <b-tooltip :target="`actions-to-edit-or-delete-initiative-${initiativeId}`" v-if="disabled">
            {{ $t('hasNotAuthorization') }}
        </b-tooltip>
    </b-dropdown>
</template>
<script>
import api from '@/services/api'
import Swal from 'sweetalert2'
import { deleteConfirmationWithLoading } from '@/config/sweet-alert'
import { success, danger } from '@/lib/notification'

export default {
    props: {
        initiativeId: Number,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        openEditInitiativeModal(initiativeId) {
            this.$bvModal.show(`edit-initiative-modal${initiativeId}`)
        },
        confirmDelete() {
            Swal({
                ...deleteConfirmationWithLoading,
            }).then((resp) => {
                const { value } = resp
                if (value) {
                    return this.deleteInitiative()
                }
            })
        },
        deleteInitiative() {
            api.delete('/initiatives/' + this.initiativeId)
                .then(() => {
                    this.showSuccessNotification()
                    this.$store.dispatch('daily/getInitiativesFromAPI')
                    this.$emit('deleted')
                })
                .catch((e) => {
                    console.error(e)
                    this.showErrorNotification()
                })
        },
        showSuccessNotification() {
            success(
                this.$t('notification.deletedSuccessfully', {
                    item: `Iniciativa`,
                })
            )
        },
        showErrorNotification() {
            danger()
        },
    },
    i18n: {
        messages: {
            'en-US': {
                hasNotAuthorization: 'You are not authorized to edit this Initiative',
            },
            'es-ES': {
                hasNotAuthorization: 'No está autorizado para editar esta iniciativa',
            },
            'pt-BR': {
                hasNotAuthorization: 'Você não tem autorização para editar esta Iniciativa',
            },
        },
    },
}
</script>
<style lang="scss" scoped>
.actions {
    display: flex;
    gap: 0.8rem;
    div {
        cursor: pointer;
    }
    z-index: 999 !important;
}
</style>
